import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import type { Role } from "../lib/store";

/**
 * Route guard. Server-side RLS (see supabase-schema.sql) is the real
 * security boundary — this only controls client-side UI routing so
 * unauthorized users don't see screens meant for other roles.
 */
export function ProtectedRoute({ allow, children }: { allow: Role[]; children: ReactNode }) {
  const { loading, session, profile } = useAuth();

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-charcoal/40">Lädt …</div>;
  }
  if (!session || !profile) return <Navigate to="/login" replace />;
  if (!allow.includes(profile.role)) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
